<template>
  <ul class="stihl-filter-chips">
    <li
      class="chip-item"
      :class="{ selected: modelValue === opt.key }"
      v-for="opt in options"
      :key="opt.key"
      @click="select(opt)"
      @keyup.enter="select(opt)">
      <a class="nav-link">
        <stihl-icon icon="check" v-if="modelValue === opt.key" />
        {{ opt.label }}
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import StihlIcon from '@/components/ui/StihlIcon.vue';

export interface FilterChip {
  key: string;
  label: string;
}

export default defineComponent({
  name: 'StihlFilterChips',
  components: { StihlIcon },
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: String, default: null },
    options: { type: Array as PropType<FilterChip[]>, required: true },
  },
  methods: {
    select(option: FilterChip) {
      this.$emit('update:modelValue', option.key);
    },
  },
});
</script>

<style>
:root {
  --stihl-filter-chips-border-color: var(--grey-mid, #DADADA);
}

ul.stihl-filter-chips {
  display: flex;
  gap: 1.25rem;
  /*flex-wrap: wrap;*/
  width: 100%;
  padding: 0;
  margin: 1rem 0;
  list-style: none;
}

.stihl-filter-chips li {
  display: inline-flex;
  height: 2rem;
  padding: 0.5rem 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  border-radius: 1rem;
  border: 1px solid var(--stihl-filter-chips-border-color);
}

.stihl-filter-chips li:hover:not(.selected) {
  --stihl-filter-chips-border-color: var(--grey-deep);
  border: 1px solid var(--grey-deep);
  cursor: pointer;
}

.stihl-filter-chips li:active {
  border-width: 2px solid var(--grey-deep);
}

.stihl-filter-chips li.selected {
  --stihl-filter-chips-border-color: var(--grey-light); /* hide it */
  background: var(--grey-light, #EDEDED);
}

.stihl-filter-chips li a {
  color: var(--grey-deep, #252525);
  font-feature-settings: 'clig' off, 'liga' off;

  /* interactive/link */
  font-family: var(--stihl-font-family-text);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem;

  user-select: none;
}
</style>
